import * as THREE from "three";
import ExtrudedLoopSubGeometry3d from "../compoundSceneGeometry/ExtrudedLoopSubGeometry3d";
import CircleAnnotationData from "../sceneObjectData/CircleAnnotationData";
import { getSceneObjectStyle, getSceneObjectStyleName, SceneObjectStyle, SceneObjectStyleEnum } from "./SceneObjectStyle";

import { LineMaterial } from "three/addons/lines/LineMaterial.js";

export default class CircleAnnotationGeometry3d extends ExtrudedLoopSubGeometry3d<CircleAnnotationData> {

    private static lineMaterialCache = new WeakMap<SceneObjectStyle, LineMaterial>();
    private static textMaterialCache = new WeakMap<SceneObjectStyle, THREE.MeshBasicMaterial>();

    private static getLineMaterial(style: SceneObjectStyle): LineMaterial {
        let mat = CircleAnnotationGeometry3d.lineMaterialCache.get(style);
        if (!mat) {
            mat = new LineMaterial({
                color: style.color,
                linewidth: style.lineWidth,
                resolution: new THREE.Vector2(window.innerWidth, window.innerHeight)
            });
            mat.name = `CircleAnnotation3d-${getSceneObjectStyleName(style)}-Line`;
            CircleAnnotationGeometry3d.lineMaterialCache.set(style, mat);
        }
        return mat;
    }

    private static getTextMaterial(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        let mat = CircleAnnotationGeometry3d.textMaterialCache.get(style);
        if (!mat) {
            mat = new THREE.MeshBasicMaterial({ color: style.color });
            mat.name = `CircleAnnotation3d-${getSceneObjectStyleName(style)}-Text`;
            CircleAnnotationGeometry3d.textMaterialCache.set(style, mat);
        }
        return mat;
    }

    constructor() {
        super(
            CircleAnnotationGeometry3d.getLineMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal)),
            CircleAnnotationGeometry3d.getTextMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal))
        );
    }

    protected getLineMaterialForStyle(style: SceneObjectStyle): LineMaterial {
        return CircleAnnotationGeometry3d.getLineMaterial(style);
    }

    protected getTextMaterialForStyle(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        return CircleAnnotationGeometry3d.getTextMaterial(style);
    }
}
